// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.profile-modal-backdrop {
  position: fixed;
  inset: 0;
  background: rgba(2, 6, 23, 0.72);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px;
  z-index: 120;
}

.profile-modal {
  width: min(520px, 100%);
  max-height: min(88vh, 760px);
  overflow: auto;
  background: var(--surface);
  border: 1px solid var(--border);
  border-radius: 16px;
  padding: 24px;
  box-shadow: var(--card-shadow);
}

.profile-modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 12px;
  margin-bottom: 20px;
}

.profile-modal-kicker {
  margin: 0 0 4px;
  color: var(--secondary-color);
  font-size: 12px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.12em;
}

.icon-button {
  border: 1px solid var(--border);
  background: transparent;
  color: var(--text);
  width: 36px;
  height: 36px;
  border-radius: 999px;
  cursor: pointer;
}

.profile-form {
  display: grid;
  gap: 14px;
}

.profile-helper {
  margin: 0;
  color: var(--muted);
  line-height: 1.5;
}

.profile-avatar-preview {
  width: 72px;
  height: 72px;
  border-radius: 50%;
  border: 1px solid var(--border);
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
  background: var(--surface-strong);
  color: var(--text);
  font-weight: 700;
  margin-bottom: 4px;
}

.profile-avatar-preview img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.profile-avatar-preview.large {
  width: 96px;
  height: 96px;
}

.profile-content {
  display: grid;
  gap: 16px;
}

.profile-card {
  border: 1px solid var(--border);
  border-radius: 12px;
  padding: 16px;
  background: var(--surface-strong);
}

.profile-card-hero {
  display: flex;
  gap: 16px;
  align-items: center;
}

.profile-card-alert {
  border-color: color-mix(in srgb, var(--secondary-color) 45%, var(--border));
}

.profile-socials {
  display: flex;
  gap: 10px;
  flex-wrap: wrap;
  margin-top: 8px;
}

.profile-socials a {
  color: var(--secondary-color);
  font-weight: 600;
  text-decoration: none;
}

.steam-link-card {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 12px;
  border: 1px solid var(--border);
  border-radius: 12px;
  padding: 12px 14px;
  background: var(--surface);
}

.secondary-button {
  border: 1px solid var(--border);
  background: transparent;
  color: var(--text);
  border-radius: 8px;
  padding: 10px 14px;
  cursor: pointer;
  font-weight: 600;
}
`, "",{"version":3,"sources":["webpack://./src/components/UserProfileModal.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,QAAQ;EACR,gCAAgC;EAChC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,YAAY;AACd;;AAEA;EACE,uBAAuB;EACvB,4BAA4B;EAC5B,cAAc;EACd,0BAA0B;EAC1B,+BAA+B;EAC/B,mBAAmB;EACnB,aAAa;EACb,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,6BAA6B;EAC7B,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,+BAA+B;EAC/B,uBAAuB;EACvB,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,SAAS;EACT,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,+BAA+B;EAC/B,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,iCAAiC;EACjC,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,+BAA+B;EAC/B,mBAAmB;EACnB,aAAa;EACb,iCAAiC;AACnC;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,2EAA2E;AAC7E;;AAEA;EACE,aAAa;EACb,SAAS;EACT,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,6BAA6B;EAC7B,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,SAAS;EACT,+BAA+B;EAC/B,mBAAmB;EACnB,kBAAkB;EAClB,0BAA0B;AAC5B;;AAEA;EACE,+BAA+B;EAC/B,uBAAuB;EACvB,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;AAClB","sourcesContent":[".profile-modal-backdrop {\r\n  position: fixed;\r\n  inset: 0;\r\n  background: rgba(2, 6, 23, 0.72);\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  padding: 24px;\r\n  z-index: 120;\r\n}\r\n\r\n.profile-modal {\r\n  width: min(520px, 100%);\r\n  max-height: min(88vh, 760px);\r\n  overflow: auto;\r\n  background: var(--surface);\r\n  border: 1px solid var(--border);\r\n  border-radius: 16px;\r\n  padding: 24px;\r\n  box-shadow: var(--card-shadow);\r\n}\r\n\r\n.profile-modal-header {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n  gap: 12px;\r\n  margin-bottom: 20px;\r\n}\r\n\r\n.profile-modal-kicker {\r\n  margin: 0 0 4px;\r\n  color: var(--secondary-color);\r\n  font-size: 12px;\r\n  font-weight: 700;\r\n  text-transform: uppercase;\r\n  letter-spacing: 0.12em;\r\n}\r\n\r\n.icon-button {\r\n  border: 1px solid var(--border);\r\n  background: transparent;\r\n  color: var(--text);\r\n  width: 36px;\r\n  height: 36px;\r\n  border-radius: 999px;\r\n  cursor: pointer;\r\n}\r\n\r\n.profile-form {\r\n  display: grid;\r\n  gap: 14px;\r\n}\r\n\r\n.profile-helper {\r\n  margin: 0;\r\n  color: var(--muted);\r\n  line-height: 1.5;\r\n}\r\n\r\n.profile-avatar-preview {\r\n  width: 72px;\r\n  height: 72px;\r\n  border-radius: 50%;\r\n  border: 1px solid var(--border);\r\n  overflow: hidden;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  background: var(--surface-strong);\r\n  color: var(--text);\r\n  font-weight: 700;\r\n  margin-bottom: 4px;\r\n}\r\n\r\n.profile-avatar-preview img {\r\n  width: 100%;\r\n  height: 100%;\r\n  object-fit: cover;\r\n}\r\n\r\n.profile-avatar-preview.large {\r\n  width: 96px;\r\n  height: 96px;\r\n}\r\n\r\n.profile-content {\r\n  display: grid;\r\n  gap: 16px;\r\n}\r\n\r\n.profile-card {\r\n  border: 1px solid var(--border);\r\n  border-radius: 12px;\r\n  padding: 16px;\r\n  background: var(--surface-strong);\r\n}\r\n\r\n.profile-card-hero {\r\n  display: flex;\r\n  gap: 16px;\r\n  align-items: center;\r\n}\r\n\r\n.profile-card-alert {\r\n  border-color: color-mix(in srgb, var(--secondary-color) 45%, var(--border));\r\n}\r\n\r\n.profile-socials {\r\n  display: flex;\r\n  gap: 10px;\r\n  flex-wrap: wrap;\r\n  margin-top: 8px;\r\n}\r\n\r\n.profile-socials a {\r\n  color: var(--secondary-color);\r\n  font-weight: 600;\r\n  text-decoration: none;\r\n}\r\n\r\n.steam-link-card {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n  gap: 12px;\r\n  border: 1px solid var(--border);\r\n  border-radius: 12px;\r\n  padding: 12px 14px;\r\n  background: var(--surface);\r\n}\r\n\r\n.secondary-button {\r\n  border: 1px solid var(--border);\r\n  background: transparent;\r\n  color: var(--text);\r\n  border-radius: 8px;\r\n  padding: 10px 14px;\r\n  cursor: pointer;\r\n  font-weight: 600;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
